<template>
  <div>
    <v-layout v-if="screener" row wrap class="mb-5" >
      <v-flex xs12>
        <v-container ma-0>
          <v-card flat color="background">
            <!-- Screener Header -->
            <ScreenerHeader
              :screener="screener"
              @onBuyTicket="initiateEnrollment"
              @onParticipate="initiateEnrollment"
              @onWatch="goToWatchPage"
              @onBuyVenueTicket="initiateEnrollment"
            ></ScreenerHeader>
            <!-- Screener Film detail -->
            <v-card-text class="px-0 pt-0">
              <Screener :screener="screener"
              @onBuyTicket="initiateEnrollment"
              @onParticipate="initiateEnrollment"
              @onWatch="goToWatchPage"
              @onBuyVenueTicket="initiateEnrollment"
              ></Screener>
            </v-card-text>
            <v-card-text class="mt-3 text-xs-center">
              <!-- Button Decider -->
              <ScreenerButton
                :buttonProps="buttonProps"
                :screener="screener"
                @onBuyTicket="initiateEnrollment"
                @onParticipate="initiateEnrollment"
                @onWatch="goToWatchPage"
                @onBuyVenueTicket="initiateEnrollment"
              />
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
    <Enrollment
      :dialog.sync="dialog"
      :screener.sync="screener"
      :pricing="pricingPlan"
      @onPurchased="goToWatchPage"
    ></Enrollment>
  </div>
</template>


<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import Screener from "@/components/screener/Screener";
import ScreenerHeader from "@/components/screener/Header";
import i18n from "@/i18n";
import rules from "@/validation";
import DEFINES from "@/defines";
import { getAddToCalLink, isDatePast } from "@/helpers";
import ScreenerButton from "@/components/screener/ScreenerButton";
import Enrollment from "@/components/company/Enrollment";
import PricingHandler from "@/components/screener/PricingHandler";
import ForgivenessOverview from "./ForgivenessOverview"
import ProgramSection from "@/components/company/program/ProgramSection.vue";

export default {
  name: "ScreenerOverview",
  metaInfo() {
  const locale = this.$i18n.locale;
  let title = "Screener";

  if (
    this.screener &&
    this.screener.title &&
    this.screener.title[locale]
  ) {
    title = this.screener.title[locale];
  } else if (
    this.screener &&
    this.screener.title &&
    this.screener.title.en
  ) {
    title = this.screener.title.en;
  }

  return {
    title
  };
}
,
  async beforeRouteEnter(to, from, next) {
    await next(vm => {
      if (to.params.screener_id) {
        vm.getScreenerFromApi();
      }
    });
  },
  watch: {
    '$route' (to, from) {
      if (to.params.screener_id != this.screener.id) {
        this.getScreenerFromApi();
      }
    },
    '$i18n.locale': function(newLocale, oldLocale) {
      this.getScreenerFromApi();
    }
  },
  data() {
    return {
      rules,
      verification: false,
      formattedNumber: null,
      translations: {
        phoneNumberLabel: i18n.t("screening.register.lable.phone")
      },
      Optionaltranslations: {
        phoneNumberLabel: i18n.t("screening.register.lable.optional")
      },
      customer: {
        name: "",
        phone: "",
        email: "",
        screener_id: null
      },
      screener: null,
      dialog: false,
      buttonProps: {
        large: true
      },
      pricingPlan: null
    };
  },
  components: {
    Screener,
    ScreenerHeader,
    ScreenerButton,
    Enrollment,
    PricingHandler,
    ForgivenessOverview,
    ProgramSection
  },
  computed: {
    ...mapState({
      currentCompany: state => state.company.company
    }),
    ...mapGetters("screening", {
      isScreeningPaid: "isScreeningPaid"
    }),
    ...mapGetters("consumer", {
      isConsumerPurchased: "isPurchased",
      vodEventStartTime: "getVodEventStartTime",
      vodEventEndTime: "getVodEventEndTime"
    }),
    isScreeningArchive: function(){
      return isDatePast(this.screener.registration_ends_at);
    }
  },
  methods: {
    async getScreenerFromApi() {
      try {
        let response = await this.$store.dispatch("screening/get", {
          id: this.$route.params.screener_id
        });
        this.screener = response.screener;
      } catch (error) {
        await this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
        if(!(this.$route.query && this.$route.query.allowEmbed)){
          this.goToCompanyDashboard();
        }
      }finally{
        if(this.$route.query.initEnr){
          this.initiateEnrollment();
        }
      }
    },
    goToCompanyDashboard() {
      this.$router.push({
        name: "company.dashboard"
      });
    },

    initiateEnrollment() {
     this.dialog = true;
    },
    goToWatchPage(screener) {
       /*
        In case of Embed, there would be a query param which we need to carry forward
        in order to hide some of the page section
       */
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: screener.id
        },
        query: {
          allowEmbed: this.$route.query && this.$route.query.allowEmbed
        }
      });
    },
    setPricingPlan(plan) {
      this.pricingPlan = plan;
    }
  }
};
</script>

<style></style>
